<form name="form" [formGroup]="form" (ngSubmit)=" submit()">
  <p>{{ 'Confrimyourpaymentbyaddingtheamountandchoosingyourpaymentmethod' | translate }}:</p>
  <div class="note-bg">
    <div class="form-group mb-0 row">
      <label class="col-lg-3 col-md-3 col-form-label" for="amount">{{ 'Amount' | translate }}</label>
      <div class="col-lg-6 col-md-6 mb-2">
        <div class="input-group">
          <input type="number" class="form-control" formControlName="amount"
          [ngClass]="{'is-invalid':submitClicked && form.get('amount').invalid}" required />
          <div class="input-group-append">
            <span class="input-group-text">
              {{currency}}
            </span>
          </div>
        </div>

        <div class="invalid-feedback" *ngIf="form.get('amount').errors!=null">
          <div *ngIf="form.get('amount').errors.required"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Amountisrequired' | translate }}</div>
          <div *ngIf="form.get('amount').errors.min"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Pleaseenteramountgreaterthan0' | translate }}</div>
        </div>
      </div>
      <div class="col-lg-3 col-md-3">
        <button type="submit" class="btn default-btn">{{ 'Pay' | translate }}</button>
      </div>
    </div>
  </div>






  <!-- <div class="form-group paymentMethod"> -->
    <ng-container  *ngIf="submitted">
      <payment-shared [caseID]="viewBooking.caseID" [rentalServiceDeliveryChannel]="rentalServiceDeliveryChannel" [paymentMode]="PaymentMode.SeparatePay" [paymentValue]="form.value['amount']" (onAnyError)="onError($event)" ></payment-shared>
    </ng-container>

  <div>



  </div>


</form>

<div class="booking-steps ml-0 mr-0">
  <button (click)="cancelClicked()" mat-button ><fa-icon class="mr-2" [icon]="faChevronCircleLeft"></fa-icon> <span class="mt-1">{{ 'Back' | translate }}</span></button>
</div>

